import React from "react";
import { useNavigate } from "react-router-dom";
import styles from "./style.module.scss";
import { MdKeyboardArrowRight } from "react-icons/md";

interface BreadcrumbItem {
  label: string;
  path?: string;
}

interface BreadcrumbProps {
  items: BreadcrumbItem[];
}

const Breadcrumb: React.FC<BreadcrumbProps> = ({ items }) => {
  const navigate = useNavigate();

  const handleClick = (path?: string) => {
    if (path) {
      navigate(path);
    }
  };

  return (
    <nav className={styles.breadcrumb} aria-label="Breadcrumb">
      <ol className={styles.breadcrumbList}>
        {items.map((item, index) => {
          const isLast = index === items.length - 1;
          return (
            <li key={index} className={styles.breadcrumbItem}>
              {!isLast && item.path ? (
                <>
                  <button
                    onClick={() => handleClick(item.path)}
                    className={styles.breadcrumbLink}
                  >
                    {item.label}
                  </button>
                  <MdKeyboardArrowRight
                    className={styles.breadcrumbSeparator}
                    size={30}
                  />
                </>
              ) : (
                <span
                  className={`${styles.breadcrumbText} ${isLast ? styles.breadcrumbActive : ""}`}
                >
                  {item.label}
                </span>
              )}
            </li>
          );
        })}
      </ol>
    </nav>
  );
};

export default Breadcrumb;
